/* eslint-disable global-require */
import desktopChar from '../assets/desktop-character.svg';
import changePass from '../assets/change-pass.svg';
import playStoreBadge from '../assets/playstore-badge.svg';
import appStoreBadge from '../assets/appstore-badge.svg';
import eyeOpen from '../assets/eye-open.png';
import eyeClosed from '../assets/eye-closed.png';
import ojkAfpi from '../assets/ojk-afpi-logo.svg';
import blackArrowDown from '../assets/icon-arrow-down.png';
import arrowUp from '../assets/icons/Arrow-up.svg';
import arrowDown from '../assets/icons/Arrow-down.svg';
import arrowRight from '../assets/icons/arrow-right.svg';
import arrowLeft from '../assets/icons/arrow-left.svg';
import editDots from '../assets/icons/Edit-dots.svg';
import redWarning from '../assets/icons/red-warning-triangle.svg';
import noData from '../assets/no-data-image.svg';
import close from '../assets/icons/close.svg';
import noFilterData from '../assets/no-filter-data.svg';
import marketplaceGray from '../assets/icons/marketplace-darkGrey.svg';
import marketplaceWhite from '../assets/icons/marketplace-white.svg';
import portofolioGray from '../assets/icons/portfolio-darkGrey.svg';
import portofolioWhite from '../assets/icons/portfolio-white.svg';
import whitePlusIcon from '../assets/icons/white-plus-icon.svg';
import marketplaceNoData from '../assets/marketplace-no-data.svg';
import successCheckGif from '../assets/gif/success-check.gif';
import loaderGif from '../assets/gif/loader-trans.gif';
import failedCheckGif from '../assets/gif/failed-check.gif';
import blueInfoIcon from '../assets/icons/blue-info-icon.svg';
import bankPlaceholder from '../assets/bank-placeholder.svg';
import bankBni from '../assets/icons/bankBni.png';
import bankBsim from '../assets/icons/bsim.svg';
import contentCopy from '../assets/icons/contentCopy.png';
import warningSign from '../assets/icons/warningSign.png';
import atmIcon from '../assets/icons/atm.png';
import chevronUp from '../assets/icons/chevronUp.png';
import chevronDown from '../assets/icons/chevronBottom.png';
import globe from '../assets/icons/globe.png';
import handphone from '../assets/icons/handphone.png';
import teller from '../assets/icons/teller.png';
import placeholderImage from '../assets/icons/placeholder_image.png';
import verifiyBadge from '../assets/icons/verify_badge.png';
import verified from '../assets/verified.png';
import outstandingAmount from '../assets/icons/outstanding-balance.svg';
import wallet from '../assets/icons/wallet.svg';
import chartLine from '../assets/icons/chart-line.svg';
import interest from '../assets/icons/interest.svg';
import processing from '../assets/icons/processing.svg';
import calendar from '../assets/icons/calendar.svg';

export interface IImage {
	src: string;
	alt: string;
}

const ImagePath = {
	lenderLogo: {
		src: 'https://cdn.danamas.co.id/public/asset/logo-danamas.svg',
		alt: 'lender-logo',
	},
	desktopCharacter: {
		src: desktopChar,
		alt: 'desktop-char',
	},
	playStoreBadge: {
		src: playStoreBadge,
		alt: 'playStore',
	},
	appStoreBadge: {
		src: appStoreBadge,
		alt: 'appStore',
	},
	eyeOpen: {
		src: eyeOpen,
		alt: 'eyeOpen',
	},
	eyeClosed: {
		src: eyeClosed,
		alt: 'eyeClosed',
	},
	ojkAfpiLogo: {
		src: ojkAfpi,
		alt: 'ojk & afpi',
	},
	blackArrowDown: {
		src: blackArrowDown,
		alt: 'arrowDown',
	},
	arrowUp: {
		src: arrowUp,
		alt: 'arrow up',
	},
	arrowDown: {
		src: arrowDown,
		alt: 'arrow down',
	},
	arrowRight: {
		src: arrowRight,
		alt: 'arrow right',
	},
	arrowLeft: {
		src: arrowLeft,
		alt: 'arrow left',
	},
	editDots: {
		src: editDots,
		alt: 'edit dots',
	},
	redWarning: {
		src: redWarning,
		alt: 'warning',
	},
	noData: {
		src: noData,
		alt: 'warning',
	},
	close: {
		src: close,
		alt: 'close',
	},
	noDataFilter: {
		src: noFilterData,
		alt: 'noFilterData',
	},
	changePass: {
		src: changePass,
		alt: 'change pass',
	},
	marketplaceGray: {
		src: marketplaceGray,
		alt: 'marketplace',
	},
	marketplaceWhite: {
		src: marketplaceWhite,
		alt: 'marketplace',
	},
	portofolioGray: {
		src: portofolioGray,
		alt: 'portofolio',
	},
	portofolioWhite: {
		src: portofolioWhite,
		alt: 'portofolio',
	},
	whitePlusIcon: {
		src: whitePlusIcon,
		alt: 'whitePlusIcon',
	},
	marketplaceNoData: {
		src: marketplaceNoData,
		alt: 'marketplaceNoData',
	},
	successCheckGif: {
		src: successCheckGif,
		alt: 'successCheckGif',
	},
	loaderGif: {
		src: loaderGif,
		alt: '',
	},
	failedCheckGif: {
		src: failedCheckGif,
		alt: 'failedCheckGif',
	},
	blueInfoIcon: {
		src: blueInfoIcon,
		alt: 'blueInfoIcon',
	},
	bankPlaceholder: {
		src: bankPlaceholder,
		alt: 'bankPlaceholder',
	},
	bankBni: {
		src: bankBni,
		alt: 'bankBni',
	},
	bankBsim: {
		src: bankBsim,
		alt: 'bankBsim',
	},
	contentCopy: {
		src: contentCopy,
		alt: 'contentCopy',
	},
	warningSign: {
		src: warningSign,
		alt: 'warningSign',
	},
	atmIcon: {
		src: atmIcon,
		alt: 'atmIcon',
	},
	chevronUp: {
		src: chevronUp,
		alt: 'chevronUp',
	},
	chevronDown: {
		src: chevronDown,
		alt: 'chevronDown',
	},
	globe: {
		src: globe,
		alt: 'globe',
	},
	handphone: {
		src: handphone,
		alt: 'handphone',
	},
	teller: {
		src: teller,
		alt: 'teller',
	},
	placeholderImage: {
		src: placeholderImage,
		alt: 'placeholderImage',
	},
	verifiyBadge: {
		src: verifiyBadge,
		alt: 'verifyBadge',
	},
	verified: {
		src: verified,
		alt: 'verified',
	},
	outstandingAmount: {
		src: outstandingAmount,
		alt: 'outstandingAmount'
	},
	wallet: {
		src: wallet,
		alt: 'wallet'
	},
	interest: {
		src: interest,
		alt: 'interest'
	},
	chartLine: {
		src: chartLine,
		alt: 'chartLine'
	},
	processing: {
		src: processing,
		alt: 'processing',
	},
	calendar: {
		src: calendar,
		alt: 'calendar',
	},
};

export default ImagePath;
